export default "__VITE_ASSET__B8cz2VOt__"